import authenticate from '@/services/authenticate'

export default [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "app-dashboard" */ '@/views/app'),
    beforeEnter: authenticate,
    redirect: '/app/dashboards',

    // Dashboards
    children: [
      {
        path: '/app/dashboards',
        component: () => import(/* webpackChunkName: "dashboards" */ '@/views/app/dashboards'),
        children: [
          {
            path: 'dashboard.v1',
            component: () => import(/* webpackChunkName: "dashboard-v1" */ '@/views/app/dashboards/dashboard.v1')
          }
        ]
      },
      // CRM
      {
        path: '/app/crm',
        component: () => import(/* webpackChunkName: "crm" */'@/views/app/crm'),
        redirect: '/app/crm/listagemdepedidos',
        children: [
          {
            path: '/app/crm/listagemdepedidos/:filtro',
            name: 'listagemdepedidos',
            component: () => import(/* webpackChunkName: "listagemdepedidos" */ '@/views/app/crm/listagemdepedidos')
          },
          {
            path: '/app/crm/alertas',
            name: 'alertas',
            component: () => import(/* webpackChunkName: "alertas" */ '@/views/app/crm/alertas')
          },
          {
            path: '/app/crm/campanhas',
            name: 'campanhas',
            component: () => import(/* webpackChunkName: "campanhas" */ '@/views/app/crm/campanhas')
          },
          {
            path: '/app/crm/campanhaslogs',
            name: 'campanhaslogs',
            component: () => import(/* webpackChunkName: "campanhaslogs" */ '@/views/app/crm/campanhaslogs')
          },
          {
            path: '/app/crm/repeticoesdepedidos',
            name: 'repeticoesdepedidos',
            component: () => import(/* webpackChunkName: "repeticoesdepedidos" */ '@/views/app/crm/repeticoesdepedidos')
          },
          {
            path: '/app/crm/controledeartes',
            name: 'controledeartes',
            component: () => import(/* webpackChunkName: "controledeartes" */ '@/views/app/crm/controledeartes')
          },
          {
            path: '/app/crm/artes',
            name: 'artes',
            component: () => import(/* webpackChunkName: "artes" */ '@/views/app/crm/artes')
          },
          {
            path: '/app/crm/tabelalucratividade',
            name: 'tabelalucratividade',
            component: () => import(/* webpackChunkName: "tabelalucratividade" */ '@/views/app/crm/tabelalucratividade')
          },
          {
            path: '/app/crm/logspedidosrecuperados',
            name: 'logspedidosrecuperados',
            component: () => import(/* webpackChunkName: "logspedidosrecuperados" */ '@/views/app/crm/logspedidosrecuperados')
          },
          {
            path: '/app/crm/listanegra',
            name: 'listanegra',
            component: () => import(/* webpackChunkName: "listanegra" */ '@/views/app/crm/listanegra')
          }
        ]
      },
      // Controle de Acesso
      {
        path: '/app/acesso',
        component: () => import(/* webpackChunkName: "controledeacesso" */'@/views/app/acesso'),
        redirect: '/app/acesso/usuarios/',
        children: [
          {
            path: '/app/acesso/usuarios/',
            name: 'usuarios',
            component: () => import(/* webpackChunkName: "usuarios" */ '@/views/app/acesso/usuarios/')
          },
          {
            path: '/app/acesso/gruposdeacesso/',
            name: 'gruposdeacesso',
            component: () => import(/* webpackChunkName: "gruposdeacesso" */ '@/views/app/acesso/gruposdeacesso/')
          },
          {
            path: '/app/acesso/modulos/',
            name: 'modulos',
            component: () => import(/* webpackChunkName: "modulos" */ '@/views/app/acesso/modulos/')
          },
          {
            path: '/app/acesso/telasdosistema/',
            name: 'telasdosistema',
            component: () => import(/* webpackChunkName: "telasdosistema" */ '@/views/app/acesso/telasdosistema/')
          },
          {
            path: '/app/acesso/dispositivos/',
            name: 'dispositivos',
            component: () => import(/* webpackChunkName: "dispositivos" */ '@/views/app/acesso/dispositivos/')
          }
        ]
      }
    ]
  },
  {
    path: '/app/sessions',
    component: () => import(/* webpackChunkName: "sessions" */ '@/views/app/sessions'),
    redirect: '/app/sessions/signIn',
    children: [
      {
        path: 'signIn',
        component: () => import(/* webpackChunkName: "signIn" */ '@/views/app/sessions/signIn')
      },
      {
        path: 'signUp',
        component: () => import(/* webpackChunkName: "signUp" */ '@/views/app/sessions/signUp')
      },
      {
        path: 'forgot',
        component: () => import(/* webpackChunkName: "forgot" */ '@/views/app/sessions/forgot')
      },
      {
        path: 'device',
        component: () => import(/* webpackChunkName: "device" */ '@/views/app/sessions/device')
      }
    ]
  }
  // Not Found
  // {
  //   path: '*',
  //   component: () => import(/* webpackChunkName: "notfound" */ '@/views/app/pages/notFound')
  // }
]
